import { useEffect, useState } from 'react';

import {
  disableAlreadySentQuestionnaireTypes,
  disableClientsWithBothQuestionnaires,
  hasEnabledSelectOption,
  isSelectOptionEnabled,
} from './utils';

import type { SelectValueType } from '../../../../../../utils/types';
import type { UseQuestionnaireSendSelectionParams } from './types';

export function useQuestionnaireSendSelection({
  providerId,
  clientOptions,
  clientOptionsLoading,
  onboardingQuestionnaires,
  intakeQuestionnaires,
}: UseQuestionnaireSendSelectionParams) {
  const [selectedClientId, setSelectedClientId] = useState<SelectValueType>('');
  const [selectedQuestionnaire, setSelectedQuestionnaire] = useState<SelectValueType>('');

  const selectableClientOptions = disableClientsWithBothQuestionnaires(
    clientOptions,
    onboardingQuestionnaires,
    intakeQuestionnaires,
  );

  let effectiveClientId = selectedClientId;
  if (selectedClientId !== '' && !isSelectOptionEnabled(selectableClientOptions, selectedClientId)) {
    setSelectedClientId('');
    effectiveClientId = '';
  }

  const selectableQuestionnaireOptions = disableAlreadySentQuestionnaireTypes(
    effectiveClientId,
    onboardingQuestionnaires,
    intakeQuestionnaires,
  );

  let effectiveQuestionnaire = selectedQuestionnaire;
  if (
    selectedQuestionnaire !== '' &&
    !isSelectOptionEnabled(selectableQuestionnaireOptions, selectedQuestionnaire)
  ) {
    setSelectedQuestionnaire('');
    effectiveQuestionnaire = '';
  }

  useEffect(() => {
    setSelectedClientId('');
    setSelectedQuestionnaire('');
  }, [providerId]);

  const hasSelectableClient = hasEnabledSelectOption(selectableClientOptions);
  const canSendQuestionnaire =
    !!effectiveQuestionnaire &&
    !clientOptionsLoading &&
    isSelectOptionEnabled(selectableClientOptions, effectiveClientId) &&
    isSelectOptionEnabled(selectableQuestionnaireOptions, effectiveQuestionnaire);

  return {
    selectedClientId: effectiveClientId,
    setSelectedClientId,
    selectedQuestionnaire: effectiveQuestionnaire,
    setSelectedQuestionnaire,
    selectableClientOptions,
    selectableQuestionnaireOptions,
    hasSelectableClient,
    canSendQuestionnaire,
  };
}
